import { render, staticRenderFns } from "./CustomSelect.vue?vue&type=template&id=209e9c52&scoped=true"
import script from "./CustomSelect.vue?vue&type=script&lang=js"
export * from "./CustomSelect.vue?vue&type=script&lang=js"
import style0 from "./CustomSelect.vue?vue&type=style&index=0&id=209e9c52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209e9c52",
  null
  
)

export default component.exports